import {NodePropertiesPane} from '../../SidePanel/RightPanel/NodePane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Model from './ModelUrl.mjs'

const PropertiesPaneUrl = (props) => (
    <NodePropertiesPane
        Model={Model}
        {...props}
    >
        <Text prop="text" />
        <LongText prop="address" />
    </NodePropertiesPane>
)

export default PropertiesPaneUrl
